<template>
    <nav class="d-flex bg-primary flex-row flex-md-column justify-content-md-center justify-content-around">
        <router-link class="mt-50 mt-md-auto mb-0" to="/statics">
            <i class="md-icon icon-dashboard"></i>
        </router-link>
        <router-link to="/stores">
            <i class="md-icon icon-local"></i>
        </router-link>
        <router-link to="/plans">
            <i class="md-icon icon-paid"></i>
        </router-link>
        <router-link class="mt-md-auto mb-md-25" to="/config">
            <i class="md-icon icon-settings"></i>
        </router-link>
    </nav>
</template>

<script>
export default {
    components:{

    }
}
</script>